import { useLinkStyles } from "./link.styles";
import { Text } from "@/base/components/index";
import { Link as RouterLink } from "react-router-dom";
import { LinkProps } from "../types/index";

export const Link = ({ to, target, type = "primary", ...props }: LinkProps) => {
  const { styles } = useLinkStyles();

  return (
    <RouterLink to={to} target={target}>
      <Text className={styles.root} type={type} {...props} />
    </RouterLink>
  );
};
